const ErrorPage = () => {
    return (
      <div>
        <h1>404!</h1>
        <p>An error has occurred!</p>
      </div>
    )
  }

  export default ErrorPage